import { types } from 'mobx-state-tree';
import { database } from '../utils/Firebase';
import RawFeedbackMapper from '../utils/mappers/RawFeedbackMapper';
import RawUserMapper from '../utils/mappers/RawUserMapper';
import FeedbackListFilter from '../utils/filtering/FeedbackListFilter';
import UserListFilterer from '../utils/filtering/UserListFilterer';

const FEEDBACK_COLLENTION = 'feedbacks';
const SLACK_USERS_COLLENTION = 'slackusers';

const RawFeedbackModel = types.model('RawFeedbackModel', {
  id: types.maybe(types.string),
  feedback: types.string,
  feedbackKind: types.maybe(types.string, ''),
  slackUserFeedbackId: types.maybe(types.string, ''),
  slackUserId: types.maybe(types.string, ''),
  submittedAt: types.maybe(types.number),
});

const SlackUserModel = types.model('SlackUserModel', {
  displayName: types.maybe(types.string, ''),
  email: types.optional(types.string, ''),
  userId: types.maybe(types.string, ''),
  userName: types.maybe(types.string, ''),
  avatarImgUrl: types.maybe(types.string, ''),
  heroImgUrl: types.maybe(types.string, ''),
  avatarMedUrl: types.maybe(types.string, ''),
});

const FeedBotStore = types
  .model('FeedBotStore', {
    rawFeedbacks: types.optional(types.array(RawFeedbackModel), []),
    slackusers: types.optional(types.array(SlackUserModel), []),
    rawFeedbacksInitialized: false,
    usersInitialized: false,
  })
  .actions(self => ({
    setRawFeedback(rawfeedbackData) {
      self.rawFeedbacks = rawfeedbackData;
      self.rawFeedbacksInitialized = true;
    },
    setSlackusers(slackUsers) {
      self.slackusers = slackUsers;
      self.usersInitialized = true;
    },
    initFeedBotStore() {
      if (!self.feetBotStoreInitialized) {
        database.collection(FEEDBACK_COLLENTION).onSnapshot((snapshot) => {
          const rawfeedbacks = [];
          snapshot.docs.forEach((docref) => {
            const doc = docref.data();
            doc.id = docref.id;
            rawfeedbacks.push(doc);
          });
          self.setRawFeedback(rawfeedbacks);
        });

        database.collection(SLACK_USERS_COLLENTION).onSnapshot((snapshot) => {
          const rawSlackUsers = [];
          snapshot.docs.forEach((docref) => {
            const userDoc = docref.data();
            rawSlackUsers.push(userDoc);
          });
          self.setSlackusers(rawSlackUsers);
        });
      }
    },
    resetfeedBotStore() {
      self.usersInitialized = false;
      self.rawFeedbacksInitialized = false;
    },
  }))
  .views(self => ({
    get feedBotStoreInitialized() {
      return self.rawFeedbacksInitialized && self.usersInitialized;
    },

    userData(userId) {
      const user = RawUserMapper(
        self.slackusers.filter(usr => usr.userId === userId),
        self.rawFeedbacks,
      );

      return user && user.length ? user[0] : [];
    },

    neutralFeedbackOfUser(userId, filterString) {
      let feedbackList = RawFeedbackMapper(self.rawFeedbacks, self.slackusers);
      feedbackList = feedbackList.filter(fb => fb.slackUserFeedbackId === userId && !fb.feedbackKind);
      if (filterString) {
        feedbackList = FeedbackListFilter(feedbackList, filterString);
      }
      feedbackList = feedbackList.sort((a, b) => b.submittedAtRaw - a.submittedAtRaw);
      return feedbackList;
    },

    positiveFeedbackOfUser(userId, filterString) {
      let feedbackList = RawFeedbackMapper(self.rawFeedbacks, self.slackusers);
      feedbackList = feedbackList.filter(fb =>
        fb.slackUserFeedbackId === userId && fb.feedbackKind === 'positive');
      if (filterString) {
        feedbackList = FeedbackListFilter(feedbackList, filterString);
      }
      feedbackList = feedbackList.sort((a, b) => b.submittedAtRaw - a.submittedAtRaw);
      return feedbackList;
    },

    usersSubmittedFeedback(userId, filterString) {
      let feedbackList = RawFeedbackMapper(self.rawFeedbacks, self.slackusers);
      feedbackList = feedbackList.filter(fb => fb.userId === userId);
      if (filterString) {
        feedbackList = FeedbackListFilter(feedbackList, filterString);
      }
      feedbackList = feedbackList.sort((a, b) => b.submittedAtRaw - a.submittedAtRaw);
      return feedbackList;
    },

    negativeFeedbackOfUser(userId, filterString) {
      let feedbackList = RawFeedbackMapper(self.rawFeedbacks, self.slackusers);
      feedbackList = feedbackList.filter(fb =>
        fb.slackUserFeedbackId === userId && fb.feedbackKind === 'negative');
      if (filterString) {
        feedbackList = FeedbackListFilter(feedbackList, filterString);
      }
      feedbackList = feedbackList.sort((a, b) => b.submittedAtRaw - a.submittedAtRaw);
      return feedbackList;
    },

    userList(filterString) {
      let userList = [];
      if (self.feedBotStoreInitialized) {
        userList = RawUserMapper(self.slackusers, self.rawFeedbacks);
        userList = UserListFilterer(userList, filterString);
      }
      return userList;
    },
    feedbackList(filterString) {
      let feedbackList = [];

      if (self.feedBotStoreInitialized) {
        feedbackList = RawFeedbackMapper(self.rawFeedbacks, self.slackusers);
        feedbackList = FeedbackListFilter(feedbackList, filterString);
        feedbackList = feedbackList.sort((a, b) => b.submittedAtRaw - a.submittedAtRaw);
      }

      return feedbackList;
    },
  }));

export default FeedBotStore;



// WEBPACK FOOTER //
// ./src/stores/FeedBotStore.js